const referral_code = (state = null, action) => {
	switch(action.type) {
		case 'SET_REFERRAL_CODE':
			return action.payload;
		default:
			return state;
	}
}

export default referral_code;